import { FiChevronsUp, FiChevronsDown } from "react-icons/fi";

export default function ButtonHide(props) {
  return (
    <div
      className={`${props.className} absolute bg-white hover:bg-gray-200 w-[36px] h-[36px] p-1 border border-tenken-gray-300 cursor-pointer`}
      onClick={props.onClick}
    >
      {props.hidden ? <FiChevronsDown size={24} /> : <FiChevronsUp size={24} />}
    </div>
  );
}
